module.exports = __webpack_public_path__ + "img/product-ketang-jbg-08.db57ce02.png";